import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const VIEWLET_ID = 'workbench.view.scm';
const VIEW_PANE_ID = 'workbench.scm';
const REPOSITORIES_VIEW_PANE_ID = 'workbench.scm.repositories';
const ISCMService = ( createDecorator('scm'));
var SCMInputChangeReason;
( (function(SCMInputChangeReason) {
    SCMInputChangeReason[SCMInputChangeReason["HistoryPrevious"] = 0] = "HistoryPrevious";
    SCMInputChangeReason[SCMInputChangeReason["HistoryNext"] = 1] = "HistoryNext";
})(SCMInputChangeReason || (SCMInputChangeReason = {})));
const ISCMViewService = ( createDecorator('scmView'));
export { ISCMService, ISCMViewService, REPOSITORIES_VIEW_PANE_ID, SCMInputChangeReason, VIEWLET_ID, VIEW_PANE_ID };
